var _rect, _path, _polygon, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOclock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "bca0b969-da00-4909-80b0-f45b795ed16e",
    "data-name": "Layer 1",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "orange",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.4279,
    y: 3.2923,
    width: 1.0465,
    height: 3.2928
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,44A22.5,22.5,0,1,1,44,21.5,22.5253,22.5253,0,0,1,21.5,44ZM21.5.0465A21.4535,21.4535,0,1,0,42.9535,21.5,21.4778,21.4778,0,0,0,21.5.0465Z",
    transform: "translate(1 1)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "29.351 30.075 21.428 24.981 21.428 10.427 22.474 10.427 22.474 24.409 29.918 29.194 29.351 30.075"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4279,
    y: 38.4143,
    width: 1.0465,
    height: 3.2928
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.8416,
    y: 20.8791,
    width: 3.2928,
    height: 1.0465
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.4143,
    y: 20.8791,
    width: 3.2928,
    height: 1.0465
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOclock);
export default __webpack_public_path__ + "static/media/oclock.056cb538e7932a80c27dbd9addac6ed4.svg";
export { ForwardRef as ReactComponent };